import React from "react";

export default function Countdown3DCopy() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999998,
        background: "white",
        color: "black",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "50px",
        fontWeight: "bold",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <style>{`
        @property --t {
          syntax: '<number>';
          initial-value: 60;
          inherits: true;
        }

        @property --s {
          syntax: '<integer>';
          initial-value: 0;
          inherits: true;
        }

        .countdown {
          --t: 60;
          --s: calc(var(--t) / 1);
          width: 20em;
          height: 20em;
          display: grid;
          place-items: center;
          animation: timer calc(var(--t) * 1s) linear forwards;
          position: relative;
        }

        .countdown::after {
          content: counter(sec, decimal-leading-zero);
          counter-reset: sec var(--s);
          font-size: 5em;
          font-family: "Ubuntu Mono", monospace;
          position: absolute;
        }

        @keyframes timer {
          to { --t: 0; }
        }

        svg {
          width: 100%;
          height: 100%;
          transform: rotate(-90deg);
        }

        circle {
          fill: none;
          stroke-width: 1 * 20em;
          stroke: silver;
        }

        circle.progress {
          stroke-linecap: round;
          stroke: hsl(calc(var(--k) * 120), 80%, 50%);
          stroke-dasharray: var(--k) 1;
          transition: stroke 0.2s linear;
        }
      `}</style>

        <div className="countdown">
          {/* <p
            style={{
              // position: "absolute",
              // top: "10px",
              fontSize: "80px",
              fontWeight: "bold",
              // marginBottom: "-30px",
            }}
          >
            Iqamah In
          </p> */}
          <svg viewBox="-10 -10 120 120">
            <circle r="50" cx="50" cy="50" />
            <circle
              className="progress"
              r="50"
              cx="50"
              cy="50"
              pathLength="1"
              style={{
                "--k": "calc(var(--t) / 60)",
              }}
            />
          </svg>
          {/* <div
            style={{
              // position: "absolute",
              // top: "10px",
              fontSize: "100px",
              fontWeight: "bold",
              marginTop: "-30px",
            }}
          >
            Seconds
          </div> */}
        </div>
      </div>
    </div>
  );
}
